<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)"></eaglei-leaflet-layer-header>

<ng-container *ngIf="error | async; let errorMessage">
    <p class="error-message">{{ errorMessage }}</p>
</ng-container>
